/**
 * Safe localStorage wrapper that handles cases where localStorage is unavailable
 * (e.g., Firefox private browsing, Safari third-party iframe restrictions)
 */

let isAvailable: boolean | null = null

const checkAvailability = (): boolean => {
  if (isAvailable !== null) {
    return isAvailable
  }

  const test = 'test'
  try {
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    isAvailable = true
    return true
  } catch {
    isAvailable = false
    return false
  }
}

export const safeLocalStorage = {
  getItem(key: string): string | null {
    if (!checkAvailability()) {
      return null
    }
    try {
      return localStorage.getItem(key)
    } catch {
      return null
    }
  },

  setItem(key: string, value: string): void {
    if (!checkAvailability()) {
      return
    }
    try {
      localStorage.setItem(key, value)
    } catch {
      // Silently fail if localStorage is unavailable
    }
  },

  removeItem(key: string): void {
    if (!checkAvailability()) {
      return
    }
    try {
      localStorage.removeItem(key)
    } catch {
      // Silently fail if localStorage is unavailable
    }
  },

  clear(): void {
    if (!checkAvailability()) {
      return
    }
    try {
      localStorage.clear()
    } catch {
      // Silently fail if localStorage is unavailable
    }
  },

  isAvailable(): boolean {
    return checkAvailability()
  }
}
